export default function Header({ title }) {
  return (
    <div className="flex w-full mb-4 ">
      <div className="bg-gray-200 w-full  border-y-2 p-3 border-gray-700">
        <b className="text-xl text-gray-700">{title}</b>
      </div>
    </div>
  );
}
